
const createObserver = (userCallback, offset) => {
	const callback = (entries, observer) => entries.forEach(entry => {
		if (entry.intersectionRatio <= 0) return
		(typeof userCallback === 'function') && userCallback(entry.target)
		observer.unobserve(entry.target)
	})
	return new IntersectionObserver(callback, {rootMargin: `${offset}px 0px ${offset}px 0px`})
}

export const onScrollTo = (input = '', callback = () => {}, options = { offset : 0 }) => {
	
	if (!input) return 
	
	const els = 
		(input instanceof Element) && [input] || 
		(typeof input === 'string') && [...document.querySelectorAll(input)]

	if (!window.IntersectionObserver) return els.map(el => callback(el))
	
	const observer = createObserver(callback, options.offset || 0)
	els.map(el => observer.observe(el))
}
